import { render } from "./TimeInput.vue?vue&type=template&id=22df67eb&ts=true"
import script from "./TimeInput.vue?vue&type=script&lang=ts"
export * from "./TimeInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__